import {useSimmerringSelectorStore} from '@/store/simmerring-selector'
import {SIMMERRING_STORE_CONSTANTS} from '@/assets/js/constants'

export function useQuerySettings() {
  const route   = useRoute()
  const router  = useRouter()
  const {unitLength, unitTemperature} = storeToRefs(useSimmerringSelectorStore())
  const {
    SIMM_MEASURE_INCH,
    SIMM_MEASURE_METRIC,
    SIMM_TEMP_CELSIUS,
    SIMM_TEMP_FAHRENHEIT
  } = SIMMERRING_STORE_CONSTANTS

  // only these values are allowed
  const ALLOWED_M = ['m', 'i'] as const
  const ALLOWED_T = ['c', 'f'] as const

  let syncingQuery = false

  watch(
    () => [route.query.measurement, route.query.temperature],
    ([qm, qt]) => {
      syncingQuery = true
      const q = {...route.query} as Record<string, string>
      let needsClean = false

      // eslint-disable-next-line eqeqeq
      if (qm != null) {
        const m = String(qm)
        if (ALLOWED_M.includes(m as any)) {
          const unitLength = m === 'm' ? SIMM_MEASURE_METRIC : SIMM_MEASURE_INCH
          useSimmerringSelectorStore().setUnitLength(unitLength)
        } else {
          useSimmerringSelectorStore().setUnitLength(SIMM_MEASURE_METRIC)
          delete q.measurement
          needsClean = true
        }
      }

      // eslint-disable-next-line eqeqeq
      if (qt != null) {
        const t = String(qt)
        if (ALLOWED_T.includes(t as any)) {
          const unitTemperature = t === 'c' ? SIMM_TEMP_CELSIUS : SIMM_TEMP_FAHRENHEIT
          useSimmerringSelectorStore().setUnitTemperature(unitTemperature)
        } else {
          useSimmerringSelectorStore().setUnitTemperature(SIMM_TEMP_CELSIUS)
          delete q.temperature
          needsClean = true
        }
      }

      if (needsClean) {
        router.replace({query: q})
      }
      nextTick(() => { syncingQuery = false })
    },
    {immediate: true}
  )

  watch(
    () => unitLength.value,
    () => {
      if (syncingQuery) {return}
      if ('measurement' in route.query) {
        const q = {...route.query} as Record<string, string>
        delete q.measurement
        router.replace({query: q})
      }
    }
  )

  watch(
    () => unitTemperature.value,
    () => {
      if (syncingQuery) {return}
      if ('temperature' in route.query) {
        const q = {...route.query} as Record<string, string>
        delete q.temperature
        router.replace({query: q})
      }
    }
  )
}
